import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';


import { DevicesComponent } from './devices/devices.component';
import { DeviceDetailComponent } from './device-detail/device-detail.component';
import { LogsComponent } from './logs/logs.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { LoginComponent } from './auth/login/login.component';
import { RegisterComponent } from './auth/register/register.component';

import { GuideComponent } from './guide/guide.component';
import { UserService } from './service/user.service';
import { AddDeviceComponent } from './add-device/add-device.component';
import { PrivacyTermsComponent } from './privacy-terms/privacy-terms.component';
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';
import { OwnersComponent } from './owners/owners.component';
import { OwnerDetailComponent } from './owner-detail/owner-detail.component';
import { OwnerAddComponent } from './owner-add/owner-add.component';
import { OwnerUsersComponent } from './owner-users/owner-users.component';
import { AddUserComponent } from './add-user/add-user.component';
import { AddGroupComponent } from './add-group/add-group.component';
import { GroupsComponent } from './groups/groups.component';
import { AliasesComponent } from './aliases/aliases.component';
import { OperationLogComponent } from './operation-log/operation-log.component';
import { ExecutionsComponent } from './executions/executions.component';
import { CreateOperatorComponent } from './create-operator/create-operator.component';
import { OtaComponent } from './ota/ota.component';
import { AliasDetailComponent } from './alias-detail/alias-detail.component';
import { JoinComponent } from './join/join.component';
import { RequestsComponent } from './requests/requests.component';
import { RequestTypesComponent } from './request-types/request-types.component';

const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  { path: 'dashboard', component: DashboardComponent, canActivate: [UserService] },
  { path: 'devices', component: DevicesComponent, canActivate: [UserService] },
  { path: 'device/:serial', component: DeviceDetailComponent, canActivate: [UserService], runGuardsAndResolvers: 'paramsOrQueryParamsChange' },
  { path: 'add-device', component: AddDeviceComponent, canActivate: [UserService] },
  { path: 'owners', component: OwnersComponent, canActivate: [UserService] },
  { path: 'add-owner', component: OwnerAddComponent, canActivate: [UserService] },
  { path: 'owner/:uid', component: OwnerDetailComponent, canActivate: [UserService] },
  { path: 'users', component: OwnerUsersComponent, canActivate: [UserService] },
  { path: 'groups', component: GroupsComponent, canActivate: [UserService] },
  { path: 'alias/:id', component: AliasDetailComponent, canActivate: [UserService] },
  { path: 'aliases', component: AliasesComponent, canActivate: [UserService] },
  { path: 'add-user', component: AddUserComponent, canActivate: [UserService] },
  { path: 'add-user/:uid', component: AddUserComponent, canActivate: [UserService], runGuardsAndResolvers: 'paramsOrQueryParamsChange' },
  { path: 'add-user/:uid/owner/:ownerUid/', component: AddUserComponent, canActivate: [UserService], runGuardsAndResolvers: 'paramsOrQueryParamsChange' },
  { path: 'add-group', component: AddGroupComponent, canActivate: [UserService] },
  { path: 'add-group/:uid', component: AddGroupComponent, canActivate: [UserService] },
  { path: 'add-group/:uid/owner/:ownerUid/', component: AddGroupComponent, canActivate: [UserService] },
  { path: 'dashboard/:serial', component: DeviceDetailComponent, canActivate: [UserService] },
  { path: 'executions', component: ExecutionsComponent, canActivate: [UserService] },
  { path: 'logs', component: LogsComponent, canActivate: [UserService] },
  { path: 'operationLog', component: OperationLogComponent, canActivate: [UserService] },
  { path: 'ota', component: OtaComponent, canActivate: [UserService] },
  { path: 'guide', component: GuideComponent, canActivate: [UserService] },
  { path: 'create-operator', component: CreateOperatorComponent },
  { path: 'login', component: LoginComponent },
  { path: 'register', component: RegisterComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: 'privacy-terms', component: PrivacyTermsComponent },
  { path: 'join/:ownerUid', component: JoinComponent },
  { path: 'requests', component: RequestsComponent, canActivate: [UserService] },
  { path: 'request-types', component: RequestTypesComponent, canActivate: [UserService] },



];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}


